import React, { useCallback, useMemo, useState } from "react"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import { Formik, Field } from "formik"
import * as Yup from "yup"
import { InputField, CheckboxField, HourField } from "../../Form/Fields"
import { USER } from "../../../django"
import {
  transformErrorForForm,
  setNullOnEmptyValues,
  fixInitialValuesNull,
} from "../../Form/Fields/utils"
import moment from "moment"
import omit from "lodash/omit"
import ModalDeleteControlloEffettuato from "../ModalDeleteControlloEffettuato"

const AttivitaSchema = Yup.object().shape({
  ora_fine: Yup.string().required("Campo obbligatorio"),
  fine_lavorazione: Yup.boolean(),
  controlli_effettuati: Yup.mixed().when(["fine_lavorazione"], {
    is: (fine_lavorazione) => {
      return fine_lavorazione
    },
    then: Yup.array().of(
      Yup.object().shape(
        {
          conforme: Yup.boolean().typeError(
            <div>
              Seleziona se la lavorazione
              <br />è conforme o non conforme.
            </div>
          ),
          note: Yup.string().when('conforme', {
            is: false,
            then: Yup.string().required("Note obbligatorie"),
          }),
        },
        ["conforme"]
      )
    ),
    otherwise: Yup.mixed().nullable(),
  }),
})

function removeControlloEffetuatiFromFormValues(values, id) {
  return {
    ...values,
    controlli_effettuati: values.controlli_effettuati.map(
      (controlloEffettuato) => {
        if (controlloEffettuato.id === id) {
          return {
            ...controlloEffettuato,
            id: null,
            conforme: "",
            note: "",
          }
        }
        return controlloEffettuato
      }
    ),
  }
}

const ModalFormAttivitaUpdate = ({
  isOpen,
  toggle,
  save,
  attivita,
  date,
  onDeleteControllo,
}) => {
  const [controlloModalDelete, setControlloModalDelete] = useState(null)
  const isModalDeleteOpen = controlloModalDelete !== null
  const closeControlloModalDelete = useCallback(() => {
    setControlloModalDelete(null)
  }, [])

  const initialValues = useMemo(() => {
    if (attivita) {
      return fixInitialValuesNull({
        ora_inizio: attivita.ora_inizio,
        id: attivita.id,
        ora_fine: attivita.ora_fine,
        fine_lavorazione: attivita.fine_lavorazione,
        controlli_effettuati: attivita.ordine
          ? attivita.lavorazione_data.controlli.map((controllo) => ({
              // Flat controllo effettuato as primary data
              id: controllo.controllo_effettuato.id,
              // Real "mandatory" stuff
              conforme: controllo.controllo_effettuato.id
                ? controllo.controllo_effettuato.conforme
                : "",
              note: controllo.controllo_effettuato.note,
              // NOTE: We move controllo data because now form
              // data is our "source of truth"
              // (not loving circular stuff)
              controllo: omit(controllo, "controllo_effettuato"),
              operatore: controllo.controllo_effettuato.operatore_data ?? {},
              // Stable stuff 4 da modal
              initialControlloEffettuato: controllo.controllo_effettuato,
            }))
          : [],
      })
    }
  }, [attivita])

  console.log(initialValues, "initialValues")

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" scrollable>
      <ModalHeader toggle={toggle}>
        {`Modifica attività - ` + moment(date).format("DD/MM/YYYY")}
      </ModalHeader>
      <Formik
        initialValues={initialValues}
        validationSchema={AttivitaSchema}
        onSubmit={(values, actions) => {
          console.log(values)
          return save(
            setNullOnEmptyValues({
              ...values,
              lavorazione: attivita.lavorazione,
              ordine: attivita.ordine,
              controlli_effettuati:
                values.ora_fine && values.fine_lavorazione
                  ? values.controlli_effettuati.map((controlloEffettuato) => ({
                      controllo: controlloEffettuato.controllo.id,
                      conforme: controlloEffettuato.conforme,
                      note: controlloEffettuato.note,
                      data: moment(date).format("YYYY-MM-DD"),
                    }))
                  : [],
            })
          ).then(
            () => {
              actions.setSubmitting(false)
            },
            (error) => {
              actions.setSubmitting(false)
              actions.setErrors(transformErrorForForm(error))
            }
          )
        }}
        render={({ handleSubmit, values, setValues, isSubmitting, errors }) => {
          console.log(values)
          return (
            <>
              <ModalBody>
                <form onSubmit={handleSubmit}>
                  {attivita && attivita.lavorazione_data && (
                    <div className="mt-2">
                      Lavorazione:{" "}
                      <strong>{attivita.lavorazione_data.nome}</strong>
                    </div>
                  )}
                  {attivita && attivita.ordine_data && (
                    <div className="mb-2">
                      Ordine:{" "}
                      <strong>
                        {attivita.ordine_data.numero_commessa} -{" "}
                        {attivita.ordine_data.cliente.nome}
                      </strong>
                    </div>
                  )}
                  <hr />
                  <div className="row">
                    <div className="col-md-4">
                      <Field
                        label="Ora inizio *"
                        type="text"
                        required
                        popperPlacement="right"
                        name="ora_inizio"
                        component={HourField}
                        className="mb-2 form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <Field
                        label="Ora fine"
                        type="text"
                        popperPlacement="right"
                        name="ora_fine"
                        component={HourField}
                        className="mb-2 form-control"
                      />
                    </div>
                  </div>
                  <Field
                    component={CheckboxField}
                    label="Fine lavorazione?"
                    disabled={!values.ora_fine}
                    name="fine_lavorazione"
                    className="mb-2"
                  />
                  <hr />
                  {values.fine_lavorazione &&
                    values.ora_fine &&
                    attivita &&
                    attivita.ordine &&
                    values.controlli_effettuati.map(
                      (controlloEffettuato, index) => {
                        const operatoreIdLavorazione =
                          controlloEffettuato.operatore.id ?? null
                        const enabled =
                          !operatoreIdLavorazione ||
                          operatoreIdLavorazione === USER.operatore.id
                        return (
                          <div key={index} className="position-relative">
                            <div className="text-center font-weight-bold">
                              Marcatura CE
                            </div>
                            {enabled && controlloEffettuato.id && (
                              <div
                                className="position-absolute"
                                style={{ top: 0, right: 10 }}
                              >
                                <Button
                                  size="sm"
                                  color="danger"
                                  onClick={() => {
                                    setControlloModalDelete(
                                      controlloEffettuato.initialControlloEffettuato
                                    )
                                  }}
                                >
                                  Cancella
                                </Button>
                              </div>
                            )}
                            <div>
                              Descrizione:{" "}
                              <strong>
                                {controlloEffettuato.controllo.descrizione}
                              </strong>
                            </div>
                            <div>
                              Frequenza:{" "}
                              <strong>
                                {controlloEffettuato.controllo.frequenza}
                              </strong>
                            </div>
                            {operatoreIdLavorazione &&
                              operatoreIdLavorazione !== USER.operatore.id && (
                                <div>
                                  Operatore:{" "}
                                  <strong>
                                    {
                                      controlloEffettuato.operatore.user
                                        .first_name
                                    }{" "}
                                    {
                                      controlloEffettuato.operatore.user
                                        .last_name
                                    }
                                  </strong>
                                </div>
                              )}
                            <hr />
                            <Field
                              component={InputField}
                              type={"select"}
                              label={"Conforme"}
                              disabled={!enabled}
                              name={`controlli_effettuati[${index}].conforme`}
                            >
                              <option value="">Non indicato</option>
                              <option value={true}>Conforme</option>
                              <option value={false}>Non Conforme</option>
                            </Field>
                            <Field
                              type="textarea"
                              label="Note"
                              disabled={!enabled}
                              className="mb-2"
                              component={InputField}
                              name={`controlli_effettuati[${index}].note`}
                            />
                          </div>
                        )
                      }
                    )}
                </form>
              </ModalBody>
              <ModalFooter className="d-flex justify-content-between">
                <Button
                  disabled={isSubmitting}
                  color="secondary"
                  onClick={toggle}
                >
                  Chiudi
                </Button>
                <Button
                  type="submit"
                  onClick={handleSubmit}
                  disabled={isSubmitting}
                  color="success"
                >
                  Salva
                </Button>
              </ModalFooter>
              <ModalDeleteControlloEffettuato
                toggle={closeControlloModalDelete}
                isOpen={isModalDeleteOpen}
                controllo={controlloModalDelete}
                onSetEliminato={() => {
                  onDeleteControllo
                    .onSuccess(() => {
                      setValues(
                        removeControlloEffetuatiFromFormValues(
                          values,
                          controlloModalDelete.id
                        )
                      )
                      closeControlloModalDelete()
                    })
                    .run(controlloModalDelete.id)
                }}
              />
            </>
          )
        }}
      />
    </Modal>
  )
}

export default ModalFormAttivitaUpdate
